import { Control, Controller, FieldErrors } from 'react-hook-form';

import { FC } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Grid, IconButton, TextField } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { IItem } from '../../../types/IItem';

type Props = {
  control: Control<IItem>;
  errors: FieldErrors<IItem>;
  t: (key: string) => string;
  paid: number;
  servicesTotal: number;
  partsTotal: number;
  last_part_payment: number;
  totalSum: number;
};

export const TicketNoteAndPaymentFields: FC<Props> = ({
  control,
  errors,
  t,
  paid,
  servicesTotal,
  partsTotal,
  last_part_payment,
  totalSum,
}) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 12 }}>
          <Controller
            control={control}
            name="note"
            render={({ field }) => (
              <TextField
                fullWidth
                label={t('editTicket.note')}
                multiline
                variant="outlined"
                size="small"
                rows={4}
                {...field}
                error={!!errors.note}
                helperText={errors.note?.message}
              />
            )}
          />
        </Grid>
      </Grid>

      <Box
        component="fieldset"
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          pl: 2,
          pr: 2,
        }}
      >
        <Grid container spacing={1} direction="column" sx={{ pt: 1 }}>
          <Grid size={{ xs: 5, sm: 5 }} sx={{ fontSize: 12 }}>
            {t('editTicket.parts_total')}: {partsTotal}
          </Grid>
          <Grid size={{ xs: 5, sm: 5 }} sx={{ fontSize: 12, mb: 1 }}>
            {t('editTicket.services_fees_total')}: {servicesTotal}
          </Grid>
          <Grid size={{ xs: 3, sm: 3 }} sx={{ mb: 1 }}>
            <Box>
              <Controller
                control={control}
                name="discount"
                render={({ field }) => (
                  <TextField
                    sx={{ width: '100%' }}
                    label={
                      <Box>
                        {t('editTicket.discount')}
                        <Tooltip title={<>{t('editTicket.discount_helper')}</>}>
                          <IconButton color="inherit">
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    {...field}
                    type="number"
                    variant="outlined"
                    size="small"
                    error={!!errors.discount}
                    helperText={errors.discount?.message}
                    slotProps={{
                      htmlInput: {
                        min: 0,
                        max: servicesTotal + partsTotal,
                        step: 0.01,
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 5, sm: 5 }} sx={{ fontSize: 12 }}>
            {t('editTicket.full_sum')}: {totalSum}
          </Grid>
          <Grid size={{ xs: 5, sm: 5 }} sx={{ fontSize: 12 }}>
            {t('editTicket.first_payment')}: {paid > 0 ? '-' : ''}
            {paid}
          </Grid>
          <Grid size={{ xs: 5, sm: 5 }} sx={{ fontSize: 12, mb: 1 }}>
            <b>
              {t('editTicket.finish_payment')}: {last_part_payment}
            </b>
          </Grid>
          <Grid size={{ xs: 3, sm: 3 }} sx={{ mb: 1, display: 'none' }}>
            <Box>
              <Controller
                control={control}
                name="last_part_payment"
                render={({ field }) => (
                  <TextField
                    label={
                      <Box>
                        {t('editTicket.finish_payment')}

                        <Tooltip
                          title={<>{t('editTicket.finish_payment_helper')}</>}
                        >
                          <IconButton color="inherit">
                            <HelpOutlineIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    }
                    {...field}
                    type="number"
                    variant="outlined"
                    size="small"
                    error={!!errors.last_part_payment}
                    helperText={errors.last_part_payment?.message}
                    slotProps={{
                      htmlInput: {
                        min: 0,
                        step: 0.01,
                        disabled: true,
                      },
                    }}
                  />
                )}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
